'use strict';

const gtm = require('./modules/google').tagManager;
const isInViewport = require('./modules/helpers/isInViewport');

const pushProductsToDataLayer = (tileSelectors) => {
    const PUSHED_CLASS = 'js-data-layer-list-pushed';
    const TILE_SELECTORS = (!tileSelectors && tileSelectors.length > 0) ? ['.js-grid-wrap:not(.js-grid-slider) .js-grid-item:not(.js-block-tile)','.drag-list-body .js-drag-list-item'] : tileSelectors;
    TILE_SELECTORS.forEach(TILE_SELECTOR => {
        const productTilesToPush = $(TILE_SELECTOR + ':not(.' + PUSHED_CLASS + ')');

        if (!productTilesToPush.length) {
            return;
        }

        productTilesToPush.each(function(_, tile) {
            const $tile = $(tile);
            const $tileDetails = $('.js-product-tile-details-content', $tile);

            if (!$tileDetails.length || !isInViewport($tileDetails, false)) {
                return;
            }

            const dataLayerProduct = $('.js-product-tile-datalayer-product', tile);

            if (!dataLayerProduct.length) {
                return;
            }

            const productData = JSON.parse(dataLayerProduct.val());
            if (productData) {
                gtm.pushProductTileView(productData);
            }

            $tile.addClass(PUSHED_CLASS);

        });
    });
};

module.exports.pushProductsToDataLayer = pushProductsToDataLayer;
